import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Grid } from 'semantic-ui-react';

import { SuccessContainer } from '../../components';

import './auth.scss';

class OrganizationWelcome extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;
    return (
      <Grid.Row>
        {/* <Grid.Column mobile={16} tablet={5} computer={5} />
        <Grid.Column mobile={16} tablet={6} computer={6}> */}
        <Container className="email-verification-container">
          <Grid>
            <Grid.Row>
              <SuccessContainer
                header={t('auth.organization_welcome.hello')}
                msg={t(
                  'auth.organization_welcome.thank_you_for_signed_up_with_takso'
                )}
                description={[
                  <span>{t('auth.organization_welcome.line1')}</span>,
                  <br />,
                  <span>{t('auth.organization_welcome.line2')}</span>,
                ]}
                success={true}
                button={t('auth.organization_welcome.back_to_home_page')}
                buttonRoute="/signin"
              />
            </Grid.Row>
          </Grid>
        </Container>
        {/* </Grid.Column>
        <Grid.Column mobile={16} tablet={5} computer={5} /> */}
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

OrganizationWelcome = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(OrganizationWelcome));

export default OrganizationWelcome;
